import axios from '@/requests';
import {SoftInfo} from '@/store/modules/softInfo/types';

export const softInfoAPI = {
    async getSoftInfoListByUid(projId: string, uid: string) {
        try {
            return await axios.get<SoftInfo[]>(
                '/SoftInfo/getSoftInfoListByUid',
                {"projId": projId, "uid": uid},
                );
        } catch (err) {
            return Promise.reject(err);
        }

    }
}